import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import RequireAuth from "@/components/RequireAuth";
import Landing from "@/pages/Landing";
import Intake from "@/pages/Intake";
import Report from "@/pages/Report";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

// Detect Emergent OAuth callback (`#session_id=...`) synchronously during render
// so that AuthCallback processes the exchange BEFORE any protected route
// attempts a /api/auth/me check (see playbook race-condition note).
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/start" element={<Intake />} />
      <Route path="/r/:reportId" element={<Report />} />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/admin"
        element={
          <RequireAuth requireAdmin>
            <Admin />
          </RequireAuth>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white text-ink-900 font-body">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors closeButton />
    </div>
  );
}

export default App;
